<template>
  <div class="container">
    <loading :active.sync="loading"></loading>
    <div>
      <h1>Security</h1>
    </div>
    <div class="row top-row-padding">
      <div class="container">
        <div class="row" v-if="getIdProvider === 'cognito'">
          <div class="col-sm">
            <h2>Change Password</h2>
            <form class="needs-margin-bottom" v-on:submit.prevent>
              <div class="form-group">
                <label for="oldPassword">Old Password</label>
                <input v-model="oldPassword"
                       type="password"
                       class="form-control"
                       placeholder="Enter Old Password">
              </div>
              <div class="form-group">
                <label for="newPassword">New Password</label>
                <input v-model="newPassword"
                       type="password"
                       class="form-control"
                       placeholder="Enter New Password">
              </div>
              <b-alert variant="success"
                       dismissible
                       :show="passwordChanged"
                       @dismissed="passwordChanged=false">
                       Password Successfully Changed
              </b-alert>
              <button v-on:click="changePassword" class="btn btn-primary">Change Password</button>
            </form>
            <h2>Change Email</h2>
            <p>Current Email: {{ getEmail }}</p>
            <form class="needs-margin-bottom" v-on:submit.prevent>
              <div class="form-group">
                <label for="newEmail">New Email</label>
                <input v-model="newEmail"
                       type="email"
                       class="form-control"
                       placeholder="Enter New Email">
              </div>
              <button v-on:click="changeEmail" class="btn btn-primary">Change Email</button>
            </form>
          </div>
          <!--<div class="col-sm">
            <form class="needs-margin-bottom" v-on:submit.prevent>
              <h2 v-if="!getMFAStatus">Enable Multifactor Auth</h2>
              <h2 v-if="getMFAStatus">Multifactor Auth is Enabled</h2>
              <label for="phone-number" v-if="!getMFAStatus">Mobile Phone Number</label>
              <input v-model="phoneNumber"
                     class="form-control needs-margin-bottom"
                     v-if="!getMFAStatus"
                     id="phone-number"
                     placeholder="Enter 10 Digit Cell Number">
              <p v-if="getMFAStatus">Mobile Phone: {{ getPhoneNumber }}</p>
              <b-alert variant="warning"
                   dismissible
                   :show="showPhoneAlert"
                   @dismissed="showPhoneAlert=false">
                   Must Enter A Valid Cell Phone Number
              </b-alert>
              <button v-if="!getMFAStatus" v-on:click="setMFA(true)" class="btn btn-primary">Enable MFA</button>
              <button v-if="getMFAStatus" v-on:click="setMFA(false)" class="btn btn-primary">Disable MFA</button>
            </form>
          </div>-->
        </div>
        <!--<div v-if="getUserType === 'business'" class="row">
          <div class="col">
            <h2>Revert back to User Account</h2>
            <button v-on:click="revertAccount" class="btn btn-primary">Revert Account</button>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import HomAptCognito from '../../../../store/lib/cognitoLogin.js'
import { mapMutations, mapGetters, mapActions } from 'vuex'
import { AsYouType, parseNumber } from 'libphonenumber-js'
// import router from '../../../../router/index.js'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  data () {
    return {
      oldPassword: null,
      newPassword: null,
      showPhoneAlert: false,
      newEmail: null,
      passwordChanged: false,
      loading: false
    }
  },
  components: {
    Loading
  },
  computed: {
    ...mapGetters('business', [
      'getMFAStatus',
      'getPhoneNumber',
      'getEmail'
    ]),
    ...mapGetters('user', [
      'getUserType'
    ]),
    ...mapGetters([
      'getIdProvider'
    ]),
    phoneNumber: {
      get () {
        return new AsYouType('US').input(this.getPhoneNumber)
      },
      set (value) {
        this.updatePhoneNumber(value)
      }
    }
  },
  methods: {
    ...mapMutations('business', [
      'updatePhoneNumber',
      'updateEmail'
    ]),
    ...mapMutations('user', [
      'updateUserType'
    ]),
    ...mapActions('business', [
      'toggleMFA',
      'syncData',
      'deleteBusinessData'
    ]),
    /* async revertAccount () {
      this.loading = true
      this.updateUserType('user')
      await this.syncData()
      this.deleteBusinessData()
      this.loading = false
      router.replace('/profile/user/profiles')
    }, */
    async setMFA (value) {
      var numb = parseNumber(this.getPhoneNumber, 'US')
      if (numb.phone) {
        this.updatePhoneNumber('+1' + numb.phone)
        try {
          await this.toggleMFA(value)
          if (this.getPhoneNumber !== null) {
            return await HomAptCognito.verifyAttribute('phone_number')
          }
        } catch (error) {
          alert(error.message)
          this.toggleMFA(false)
        }
        this.showPhoneAlert = false
      } else {
        this.showPhoneAlert = true
      }
    },
    async changePassword () {
      try {
        await HomAptCognito.changePasswordCognito(this.oldPassword, this.newPassword)
        this.oldPassword = null
        this.newPassword = null
        this.passwordChanged = true
      } catch (error) {
        alert(error.message)
      }
    },
    async changeEmail () {
      var oldEmail = this.getEmail
      try {
        await HomAptCognito.updateUserEmail(this.newEmail)
        this.updateEmail(this.newEmail)
        this.newEmail = null
        return await HomAptCognito.verifyAttribute('email')
      } catch (error) {
        alert(error.message)
        this.newEmail = null
        this.updateEmail(oldEmail)
        HomAptCognito.updateUserEmail(oldEmail)
      }
    }
  },
  mounted () {
    this.$global.gaEvent('userSecurity', 'navigation')
  }
}
</script>

<style scoped>
.needs-margin-bottom {
  margin-bottom: 1rem !important;
}

.container {
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/shared/security/Security.vue